import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule,ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import { EstimateDetailsService } from './estimate-details-service';
import { jsPDF } from 'jspdf';
import { Canvg } from "canvg";
import html2canvas from "html2canvas";
import { Loading } from '../loading/loading';
import { GlobalVariable } from '../globals';
import { GarageDetailsService } from '../garage-details/garage-details-service';

interface DpPanel {
  id: number;
  name: string;
  part: string;
   prices: number[];
  selected: boolean;
}

@Component({
  selector: 'estimate-details/:id/:name',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule, HttpClientModule, Loading,ReactiveFormsModule],
  templateUrl: './estimate-details.html',
  styleUrls: ['./estimate-details.scss']
})
export class EstimateDetails implements OnInit {
  categoryId: number | null = null;
  showFullDescription: boolean = false;
  showFullContent:boolean = false;
  subCategoryId: number | null = null;
  showPendingInfo: boolean = false; 
  serviceId: any;
  fromPage: string | null = null;
  callbackForm: FormGroup;
  serviceName: any;
  taxes: number = 0;
  showDpPanels: boolean = false;
  activeInfoPanel: any = null;
  currentView: string = 'Front';  
  vehicleDetails: any = null;
  submitted = false;
  categoryName: string = '';
  isNavbarWhite = false;
  showQuickBooking = false;
   showRequestBtn = false;
   isPageLoading = true;  
  // Denting & Painting Panels
  allDpPanels: Record<string, DpPanel[]> = {
   Front: [
      { id: 1, name: 'Front Bumper', part: 'Bumper', prices: [1000,1200,1400,1600,1800,2000], selected: false },
      { id: 2, name: 'Bonnet', part: 'Bonnet', prices: [1000,1200,1400,1600,1800,2000], selected: false }
    ],

   Rear: [
      { id: 3, name: 'Rear Bumper', part: 'Bumper', prices: [1000,1200,1400,1600,1800,2000], selected: false },
      { id: 4, name: 'Boot', part: 'Boot', prices: [1000,1200,1400,1600,1800,2000], selected: false }
    ],

    Left: [
      { id: 6, name: 'Left Front Door', part: 'Door', prices: [1000,1200,1400,1600,1800,2000], selected: false },
      { id: 7, name: 'Left Running Board', part: 'Running Board', prices: [1000,1200,1400,1600,1800,2000], selected: false },
      { id: 8, name: 'Left Fender', part: 'Fender', prices: [1000,1200,1400,1600,1800,2000], selected: false },
      { id: 9, name: 'Left Rear Door', part: 'Door', prices: [1000,1200,1400,1600,1800,2000], selected: false },
      { id: 10, name: 'Left Quarter Panel', part: 'Quarter Panel', prices: [1000,1200,1400,1600,1800,2000], selected: false }
    ],


    Right: [
      { id: 11, name: 'Right Front Door', part: 'Door', prices: [1000,1200,1400,1600,1800,2000], selected: false },
      { id: 12, name: 'Right Running Board', part: 'Running Board', prices: [1000,1200,1400,1600,1800,2000], selected: false },
      { id: 13, name: 'Right Fender', part: 'Fender', prices: [1000,1200,1400,1600,1800,2000], selected: false },
      { id: 14, name: 'Right Rear Door', part: 'Door', prices: [1000,1200,1400,1600,1800,2000], selected: false },
      { id: 15, name: 'Right Quarter Panel', part: 'Quarter Panel', prices: [1000,1200,1400,1600,1800,2000], selected: false }
    ],
    'Full Body': [
      { id: 16, name: 'Full Body Paint', part: 'Full Body', prices: [5000,6000,6500,7000,7500,10000], selected: false }
    ]
  };

  carSizeIndexMap: Record<string, number> = {
    es: 0, // Small
    s: 1,  // Compact
    c: 2,  // Mid-Size
    m: 3,  // Full-Size
    l: 4,  // Large
    f: 5,  // Extra Large
    ps: 6  // Premium SUV same as Extra Large
  };

  serviceDetail: any = {
    serviceKitDefinition: {
      image: null,
      notes: null,
      heading: null,
      description: null,
      content: null
    },
    parts: [],
    labours: [],
    whatsIncluded: [],
    faqs: []
  };
  loading = false;
  grandTotal: any;
  labourGstRate: any;
  successMessage: string = '';
  userId = GlobalVariable.userId;
  issue: any;
  submittedName: string = '';
  submittedMobile: string = '';
  garageShortName: any;
   key: any;  
  garageKey: string = '';
  garageData: any;
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private garageService: GarageDetailsService,
    private service: EstimateDetailsService) {this.callbackForm = this.fb.group({
      name: ['', Validators.required],
      mobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
       email: [''],
      issue: [''],
      registrationNumber: ['', [
        Validators.required,
        Validators.pattern('^[A-Z]{2}\\s[0-9]{2}\\s[A-Z]{1,2}\\s[0-9]{4}$')
      ]]
    });}

    ngOnInit(): void {
      this.key = localStorage.getItem('garageKey');
      this.route.paramMap.subscribe(params => {
        const idParam = params.get('id');

        this.serviceId = idParam ? Number(idParam) : null;
        this.serviceName = params.get('name');
      });

      this.route.queryParams.subscribe(q => {
        this.fromPage = q['from'] || null;
        console.log("Came From:", this.fromPage);

      let carSize = this.route.snapshot.queryParamMap.get('carSize');

      if (!carSize) {
        const vehicleDataStr = localStorage.getItem('vehicleData');
        if (vehicleDataStr) {
          const vehicleData = JSON.parse(vehicleDataStr);
          carSize = vehicleData.carSize; // 'es' in your example
          console.log('carSize loaded from localStorage vehicleData:', carSize);
        }
      }

      carSize = carSize || 'c'; 

      if (!this.vehicleDetails) this.vehicleDetails = {};
      this.vehicleDetails.carSize = carSize;

      console.log('vehicleDetails.carSize set to:', this.vehicleDetails.carSize);

      });

      if (this.serviceId && this.serviceName) {
        this.fetchServiceDetail();
      } else {
        console.error('Route params missing: serviceId or serviceName');
      }
      this.garageShortName = localStorage.getItem('garageShortName') || 'Laksh';
      this.loadGarageDetails();
  }
  @HostListener('window:scroll', [])
    onWindowScroll() {
      this.isNavbarWhite = window.scrollY > 50;
  }
  fetchServiceDetail() {
    this.loading = true;
    if (!this.serviceId || !this.serviceName) return;
    this.service.getServiceDetail(this.serviceId, this.serviceName).subscribe({
      next: (response: any) => {
        this.loading = false;
        console.log('API Response:', response);
        const data = response?.data || {};
        const prevCarSize = this.vehicleDetails?.carSize;
        this.serviceDetail.serviceKitDefinition = {
          image: data.serviceKitDefinition?.image ?? null,
          notes: data.serviceKitDefinition?.notes ?? null,
          heading: data.serviceKitDefinition?.heading ?? null,
          description: data.serviceKitDefinition?.description ?? null,
          content: data.serviceKitDefinition?.content ?? null
        };
        this.vehicleDetails = {
          ...data.vehicle,
          ...data.vehicleDetails,
          carSize: prevCarSize || data.vehicle?.carSize || data.vehicleDetails?.carSize || 'c'
        };
        this.serviceDetail.parts = data.parts ?? [];
        this.serviceDetail.labours = data.labours ?? [];
        this.categoryName = data.categoryName || data.category?.name || '';
        this.serviceDetail.whatsIncluded = data.whatsIncluded ?? [];
        this.serviceDetail.faqs = data.faqs ?? [];
        this.loading = false;
        this.serviceDetail.grandTotal = data.grandTotal ?? 0;
        this.grandTotal = this.serviceDetail.grandTotal;
        if (data.labours && data.labours.length > 0) {
          this.labourGstRate = data.labours[0].gstRate;
        } else {
          this.labourGstRate = null;
        }
      },
      
      error: (error: any) => {
        console.error('Error fetching service details:', error);
        this.loading = false;
      }
    });
  }

  downloadPDF() {
    // Find the element you want to capture
    const element = document.querySelector('.estimate-details-main-page') as HTMLElement;
    
    // Check if the element exists
    if (!element) {
      console.error('Element not found!');
      return;
    }

    // Capture the element and convert it into a canvas
    html2canvas(element, { scale: 2 }).then(canvas => {
      // Get image data from the canvas
      const imgData = canvas.toDataURL('image/png');

      // Create a new PDF document
      const pdf = new jsPDF('p', 'mm', 'a4'); // 'p' for portrait orientation

      // Get the image properties to maintain aspect ratio
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = 210; // A4 width in millimeters
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      // Add the image to the PDF document
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

      // Save/download the PDF with the given filename
      pdf.save('estimate-details.pdf');
    }).catch(err => {
      console.error('Failed to generate PDF:', err);
    });
  }
  downloadPDFRedirectToDownloadPage(){
      this.router.navigate(['/estimate-details-download']);
  }
  get hasPendingParts(): boolean {
    return this.pendingPartNames.length > 0;
    if (!this.serviceDetail.parts || this.serviceDetail.parts.length === 0) return false;
    return this.serviceDetail.parts.some(
      (part: any) => !part.brandName || part.zohoPartPrice === null
    );
  }

  get partsSubtotal(): number {
    if (!this.serviceDetail.parts || this.serviceDetail.parts.length === 0) return 0;
    return this.serviceDetail.parts.reduce((sum: number, part: any) => {
      return sum + (part.zohoPartPrice ? part.zohoPartPrice : 0);
    }, 0);
  }

  get pendingPartNames(): string[] {
      if (!this.serviceDetail?.parts || this.serviceDetail.parts.length === 0) return [];
      return this.serviceDetail.parts
        .filter((part: any) => !part.zohoPartPrice) // price missing
        .map((part: any) => part.partName || 'Unnamed Part');
    }


  get labourSubtotal(): number | null {
    if (!this.serviceDetail.labours || this.serviceDetail.labours.length === 0) return null;
    const total = this.serviceDetail.labours.reduce((sum: number, labour: any) => {
      return sum + (labour.labourRate ? labour.labourRate : 0);
    }, 0);
    return total > 0 ? total : null;
  }

  get taxAmount(): number | null {
    if (this.hasPendingParts) return null; // Taxes cannot be shown
    if (this.labourSubtotal || this.partsSubtotal) {
      const base = (this.partsSubtotal ?? 0) + (this.labourSubtotal ?? 0);
      return base > 0 ? Math.round(base * 0.18) : null; // 18% GST
    }
    return null;
  }

  get estimatedTotal(): number | null {
    if (this.hasPendingParts) return null; // Estimated total pending
    return (this.partsSubtotal ?? 0) + (this.labourSubtotal ?? 0) + (this.taxAmount ?? 0);
  }

//  submitForm() {
//     if (this.callbackForm.invalid) return;

//     const { name, mobile, issue } = this.callbackForm.value;

//     const payload = {
//       garageKey: this.key,
//       userId: this.userId,
//       name,
//       phoneNumber: mobile,
//       issue,
//     };

//     this.service.createBooking(payload).subscribe({
//       next: (res) => {
//         if (res.code === 200) {
//           this.successMessage = `Thank you ${payload.name} for Your Interest and Consideration`;

//           // ✅ hide the request callback modal first
//           const requestModalEl = document.getElementById('requestCallBackModal');
//           const requestModal = (window as any).bootstrap.Modal.getInstance(requestModalEl);
//           requestModal?.hide();

//           // ✅ wait a tick before showing success modal
//           setTimeout(() => {
//             const successModalEl = document.getElementById('successModal');
//             if (successModalEl) {
//               const successModal = new (window as any).bootstrap.Modal(successModalEl);
//               successModal.show();
//             }
//           }, 200);

//           // reset form
//           this.callbackForm.reset();
//           // this.selectedCoupon = null;
//         } else {
//           alert('Something went wrong. Please try again.');
//         }
//       },
//       error: (err: any) => {
//         console.error('Error creating booking:', err);
//         alert('Error creating booking. Please try again.');
//       }
//     });
//   }

  submitForm() {
     this.submitted = true;
    // Mark all fields as touched to trigger validation messages
    this.callbackForm.markAllAsTouched();

    // Stop if form is invalid
    if (this.callbackForm.invalid) {
      return;
    }

    // Check if garage is selected
    const garageKey = localStorage.getItem('garageKey');
    if (!garageKey) {
      alert("Garage not selected!");
      return;
    }

    const { name, mobile, email, issue,registrationNumber } = this.callbackForm.value;
    this.issue = this.serviceName || 'Service Request';

    // Prepare payload
    const payload = {
      garageKey: garageKey,
      serviceId: this.serviceId,
      userId: this.userId,
      name,
      phoneNumber: mobile,
      email, // optional
      issue : this.issue,
      registrationNumber: registrationNumber 

    };

    localStorage.setItem("serviceId",this.serviceId);


    this.service.createBooking(payload).subscribe({
      next: (res) => {
        if (res.code === 200) {
          // Set success message
          this.successMessage = `Thank you ${payload.name} for Your Interest and Consideration`;

          // Close request callback modal
          const requestModalEl = document.getElementById('requestCallBackModal');
          const requestModal = (window as any).bootstrap.Modal.getInstance(requestModalEl);
          requestModal?.hide();

          // Show success modal after a short delay
          setTimeout(() => {
            const successModalEl = document.getElementById('successModal');
            if (successModalEl) {
              const successModal = new (window as any).bootstrap.Modal(successModalEl);
              successModal.show();
            }
          }, 200);

          // Store the submitted name and mobile for navigation
          this.submittedName = name;
          this.submittedMobile = mobile;

          // Reset the form
          this.callbackForm.reset();
           this.submitted = false;

        } else {
          alert('Something went wrong. Please try again.');
        }
      },
      error: () => {
        alert('Error creating booking. Please try again.');
      }
    });
  }

  closeSuccessModal() {
    // Close the success modal
    const successModalEl = document.getElementById('successModal');
    const successModal = (window as any).bootstrap.Modal.getInstance(successModalEl);
    successModal?.hide();

    // Navigate to download page
    // this.router.navigate(
    //   ['/estimate-details-download'],
    //   {
    //     state: {
    //       customerName: this.submittedName,
    //       customerPhoneNumber: this.submittedMobile
    //     }
    //   }
    // );
  }
  toggleContent() {
  this.showFullContent = !this.showFullContent;
}
  toggleDescription() {
    this.showFullDescription = !this.showFullDescription;
  }
  get serviceMetaInfo() {
    if (!this.serviceName) return null;

    const name = this.serviceName.toLowerCase();

    if (name.includes('oil')) {
      return {
        time: 'Time Taken: ~4 hours',
        interval: 'Recommended every: 5,000 km / 3 months'
      };
    }

    if (name.includes('complete')) {
      return {
        time: 'Time Taken: ~6 hours',
        interval: 'Recommended every: 10,000 km / 6 months'
      };
    }

    if (name.includes('major')) {
      return {
        time: 'Time Taken: ~8 hours',
        interval: 'Recommended every: 20,000 km / 12 months'
      };
    }

    return null;
  }
  togglePanel(panel: any) {
    panel.selected = !panel.selected;
  }

  get dpPanels() {
    return this.allDpPanels[this.currentView] || [];
  }

  get selectedPanels() {
    return Object.values(this.allDpPanels)
      .flat()
      .filter((panel: any) => panel.selected);
  }

  get dpTotal() {
    return this.selectedPanels.reduce(
      (sum, panel) => sum + this.getPanelPrice(panel),
      0
    );
  }

  changeView(view: string) {
    this.currentView = view;
  }

  openInfo(panel: any) {
    this.activeInfoPanel = panel;
  }

  closeInfo() {
    this.activeInfoPanel = null;
  }
  getPanelPrice(panel: DpPanel): number {
    const size = this.vehicleDetails?.carSize?.toLowerCase() || 'c';
    let index = this.carSizeIndexMap[size] ?? 2; // default to mid-size

    // Ensure index is within prices array bounds
    if (index >= panel.prices.length) {
      index = panel.prices.length - 1;
    }

    return panel.prices[index] ?? 0;
  }

  formatRegistrationNumber() {
  let value = this.callbackForm.get('registrationNumber')?.value || '';

  value = value.toUpperCase().replace(/[^A-Z0-9]/g, '');

  if (value.length > 2) value = value.slice(0, 2) + ' ' + value.slice(2);
  if (value.length > 5) value = value.slice(0, 5) + ' ' + value.slice(5);
  if (value.length > 8) value = value.slice(0, 8) + ' ' + value.slice(8, 12);

  this.callbackForm.get('registrationNumber')?.setValue(value, { emitEvent: false });
}
scrollTo(sectionId: string) {
  const el = document.getElementById(sectionId);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Close mobile menu after click
  const offcanvasEl = document.querySelector('.offcanvas.show');
  if (offcanvasEl) {
    (window as any).bootstrap.Offcanvas.getInstance(offcanvasEl)?.hide();
  }
}
goToGarageDetails() {
  this.router.navigate(['/garage-details', this.key]);
}

  openRequestModal() {
    console.log('Request modal opened');
  }
loadGarageDetails() {
  this.isPageLoading = true;

  this.garageService.getGarageDetails(this.key).subscribe({
    next: (res) => {
      if (res.code === 200 && res.data) {
        this.garageData = res.data;

        this.garageShortName = this.garageData.garageShortName || '';

        // garage logo
        this.garageData.primaryLogo = this.garageData?.garageLogo
          ? this.garageData.garageLogo.split(',')[0].trim()
          : 'assets/img/logos/autoverse-logo-with-text.jpg';

        if (this.garageData.insuranceUrl) {
          this.garageData.insuranceUrls =
            this.garageData.insuranceUrl.split(',').filter((url: any) => url);
        }
      }

      this.isPageLoading = false;
    },
    error: (err) => console.error(err)
  });
}
}
